<div class="text-center mb-4">
  <button class="btn btn-link text-muted pt-0" (click)="startOver()">Start Over</button>
</div>
